import EmployeeRatesOverview from "./EmployeeRatesOverview";

export default EmployeeRatesOverview;
